export const BUSINESS_PHONE = '819-350-3027';

// Migrate the former call number in existing profiles without changing WhatsApp
// or replacing a different phone number intentionally saved by an administrator.
export function resolveBusinessPhone(value) {
  const digits = String(value || '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  return !digits || digits === '8196490166' ? BUSINESS_PHONE : value;
}
